module.exports = __webpack_public_path__ + "static/media/31_A.94d8a74a.png";